import { call, all, put, takeEvery } from 'redux-saga/effects';
import {
    getManageEmployeesSuccessAction,
    getManageEmployeesFailureAction,
    setManageEmployeesFailureAction,
    setManageEmployeesSuccessAction,
    getManageEmployeesAction,
    setDropDownFailureAction,
    setDropDownSuccessAction,
    setUpdateStatusSuccessAction,
    setUpdateStatusFailureAction,
    setUpdateManagerSuccessAction,
    setUpdateManagerFailureAction,
    adminResetAssessmentSuccessAction,
    adminResetAssessmentFailureAction,

} from '../../features/ManageEmployees/manageEmployeesSlice';
import URLs from '../../../constants/urls';
import { GET_MANAGE_EMPLOYEE,
  SET_MANAGE_EMPLOYEE,
  UPDATE_MANAGE_EMPLOYEE,
  SET_MANAGE_EMPLOYEE_CYCLE_DROPDOWN,
  SET_MANAGE_EMPLOYEE_UPDATE_STATUS,
  SET_MANAGE_EMPLOYEE_UPDATE_MANAGER,
  ADMIN_RESET_ASSESSMENT } from '../../actions/ManageEmployee/ManageActionType';
import { apiPython as api } from '../../../service/api';
import { getManageExternalUserAction } from '../../features/ManageExternalUsers/ManageExternalUsersSlice';

/**
 * POST Admin/ResetEmployeeAssessment — admin-initiated reset from Manage Employee.
 * Payload is emitted as PascalCase keys from ResetAssessmentModal for FastAPI schema compatibility.
 */
export function* adminResetAssessmentSaga({ payload }) {
  try {
    console.info('[Admin Reset] calling endpoint', URLs.ADMIN_RESET_EMPLOYEE_ASSESSMENT, payload);
    const response = yield call(api.post, URLs.ADMIN_RESET_EMPLOYEE_ASSESSMENT, payload);
    const msg =
      response?.data?.message ||
      response?.data?.data?.message ||
      (typeof response?.data?.data === 'string' ? response.data.data : null) ||
      'Assessment reset completed successfully.';
    yield put(adminResetAssessmentSuccessAction({ message: msg }));
    yield put(getManageEmployeesAction());
  } catch (error) {
    const err = error?.response?.data;
    const msg =
      (typeof err === 'string' && err) ||
      err?.message ||
      error?.message ||
      'Assessment reset failed.';
    yield put(adminResetAssessmentFailureAction(typeof msg === 'string' ? msg : JSON.stringify(msg)));
  }
}

export function* getmanageemployeeCyclesSaga() {
  
  try {
    const response = yield api.get(URLs.GET_MANAGE_EMPLOYEE);
    yield put(getManageEmployeesSuccessAction(response.data));
  } catch (error) {
    yield put(getManageEmployeesFailureAction(error));
  }
}


export function* setManageEmployeeCyclesSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SET_MANAGE_EMPLOYEE, body);
    yield put(setManageEmployeesSuccessAction(response.data));
    yield put(getManageEmployeesAction());
  } catch (error) {
    const err = error?.response?.data;
    const msg =
      err?.message ||
      (typeof err?.data === 'string' && err.data) ||
      'Could not save employee(s). Check email and Workday configuration.';
    yield put(setManageEmployeesFailureAction(msg));
  }
}

export function* setUpdateManageEmployeeCyclesSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.UPDATE_MANAGE_EMPLOYEE, body);
    yield put(setManageEmployeesSuccessAction(response.data));
    yield put(getManageEmployeesAction());
  } catch (error) {
    const err = error?.response?.data;
    const msg =
      (typeof err?.data === 'string' && err.data) ||
      err?.message ||
      'Could not update employee.';
    yield put(setManageEmployeesFailureAction(msg));
  }
}



export function* setDropDownListSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SET_MANAGE_EMPLOYEE_CYCLE_DROPDOWN, body);
    yield put(setDropDownSuccessAction(response.data));
    if (response.data.data === 1) yield put(getManageEmployeesAction());
  } catch (error) {
    yield put(setDropDownFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Could not save'));
  }
}




export function* getmanageEmployeeUpdateSaga({ payload: id }) {
  try {
    const response = yield api.get(`${URLs.GET_MANAGE_SKILLSDATA}?id=${id}`);
    yield put(getManageEmployeeUpdateSuccessAction(response.data.data));
  } catch (error) {
    yield put(getManageEmployeeUpdateFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Fetch failed'));
  }
}


export function* setUpdateStatusListSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SET_MANAGE_EMPLOYEE_UPDATE_STATUS,body);
    if (response.data === 1) {
      yield put(getManageExternalUserAction());
    }
  } catch (error) {
    // yield put(setUpdateStatusFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Could not save'));
  }
  
}

export function* setUpdateManagerListSaga({ payload: body }) {
  try {
    const response = yield api.post(URLs.SET_MANAGE_EMPLOYEE_UPDATE_MANAGER,body);
    yield put(setUpdateManagerSuccessAction(response.data));
    yield put(getManageEmployeesAction());
  } catch (error) {
    yield put(setUpdateManagerFailureAction(error?.response?.data?.message ? error?.response?.data?.message : 'Could not save'));
  }
  
}



export function* watchmanageEmployee() {
  yield takeEvery(GET_MANAGE_EMPLOYEE, getmanageemployeeCyclesSaga);
  yield takeEvery(SET_MANAGE_EMPLOYEE, setManageEmployeeCyclesSaga);
  yield takeEvery(UPDATE_MANAGE_EMPLOYEE, setUpdateManageEmployeeCyclesSaga);
  yield takeEvery(SET_MANAGE_EMPLOYEE_CYCLE_DROPDOWN, setDropDownListSaga);
  yield takeEvery(SET_MANAGE_EMPLOYEE_UPDATE_STATUS, setUpdateStatusListSaga);
  yield takeEvery(SET_MANAGE_EMPLOYEE_UPDATE_MANAGER,setUpdateManagerListSaga);
  yield takeEvery(ADMIN_RESET_ASSESSMENT, adminResetAssessmentSaga);

}

export default function* manageEmployeeSaga() {
  yield all([watchmanageEmployee()]);
}